import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

/*
meta:{
  title:string        必填，页面名称，显示在标题栏
  roles:string[]      必填，可访问页面的权限列表。暂时设为['admin']，登录页面给所有用户设置了'admin'权限 TODO
  hidden?:boolean     可选，是否隐藏导航，通常：详情页面传参进入不显示在导航列表
  icon?:string        可选，使用左侧导航时，显示的导航图标。头部导航默认隐藏图标。使用 components/SvgIcon组件 + iconfont图标库项目
  alwaysShow?:boolean 可选，是否显示子导航，当只有一个 hidden不为true 的子元素时，设置是否渲染子导航。alwaysShow:true 渲染 el-sub-menu，否则渲染 el-menu
  keepAlive?:boolean  可选，是否缓存页面
}
*/

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home-yinhe.vue'),
    meta: { title: '生态' },
  },
  {
    path: '/home-gotion',
    name: 'HomeGotion',
    component: () => import('../views/Home.vue'),
    meta: { title: '生态' },
  },
  // {
  //   path: '/home',
  //   name: 'DigitalProcess',
  //   component: () => import('../views/digital-process.vue'),
  //   meta: { title: '生态' },
  // },
  {
    path: '/energy-storage-1',
    name: 'EnergyStoragePowerStation1',
    component: () => import('../views/EnergyStoragePowerStation.vue'),
    meta: { title: '庐江一期', hidden: true },
  },
  {
    path: '/energy-storage',
    name: 'EnergyStoragePowerStation',
    component: () => import('../views/EnergyStorageMap.vue'),
    meta: { title: '地图', hidden: false },
  },
  {
    path: '/energy-storage-2',
    name: 'EnergyStoragePowerStation2',
    component: () => import('../views/EnergyStoragePowerStation.vue'),
    meta: { title: '庐江二期', hidden: true },
  },
  {
    path: '/energy-storage-3',
    name: 'EnergyStoragePowerStation3',
    component: () => import('../views/EnergyStoragePowerStation.vue'),
    meta: { title: '庐江三期', hidden: true },
  },
  {
    path: '/energy-storage-4',
    name: 'EnergyStoragePowerStation4',
    component: () => import('../views/EnergyStoragePowerStation.vue'),
    meta: { title: '中天钢铁', hidden: true },
  },
  {
    path: '/energy-storage-5',
    name: 'EnergyStoragePowerStation5',
    component: () => import('../views/EnergyStoragePowerStation.vue'),
    meta: { title: '永钢', hidden: true },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { title: '404', hidden: true },
  },
  {
    path: '/AI',
    name: 'AI',
    component: () => import('../views/AIWrap.vue'),
    meta: { title: 'AI', hidden: true },
  },
  {
    path: '/:path(.*)*',
    redirect: '/404',
    name: '404Page',
    meta: {
      title: '404',
      hidden: true,
    },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
})

export default router
